"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.error = void 0;
function error(message) {
    throw new Error(message);
}
exports.error = error;
